import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  itemValue = new Subject();

  setSessionStorage(name: any, value: any) {
    localStorage.setItem(name, value);
    this.itemValue.next(value);
  }

  getSessionStorage(name: any) {
    return localStorage.getItem(name);
  }

  removeSessionStorage(name: any) {
    localStorage.removeItem(name);
  }

  setObjectSessionStorage(name: string, value: any) {
    localStorage.setItem(name, JSON.stringify(value));
    this.itemValue.next(value);
  }
}
